module.exports={
    // API_URL: "http://localhost:5500/app-server/api/v1",
    API_URL: "https://ecpaygaterpi-001-site6.btempurl.com/app-server/api/v1"
}